/**
 * YUMIX — Central legal document hub.
 *
 * Single source of truth for the legal doc URL used everywhere:
 *   - Sign-up consent checkbox (AuthEmail)
 *   - Settings > Légal section
 *   - Any future footer / NDA references
 *
 * The document covers: CGU, Politique de Confidentialité, Avis de
 * Non-Responsabilité Médicale, et clause de non-divulgation intégrée.
 * Aucun NDA séparé n'est créé — conforme à la directive "tendance mondiale".
 */

export const LEGAL_DOC_URL =
  'https://docs.google.com/document/d/1N8dN25nWFOw6iO8TnwaK5k3TqfhHU5p6ygiwovnoSAI/edit?usp=sharing';

// Consent version — bump this whenever the legal doc has a material change
// so you can later ask already-registered users to re-accept.
export const LEGAL_CONSENT_VERSION = '2026-04-23';
